export default {
  futura400: 'FUTURAPTLIGHT',
  futura500: 'FUTURAPTBOOK',
  futura600: 'FUTURAPTBOLD',
};
